/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Home_Waiting_MoreInputs */



/**
* | output |
* | --- |
* | "and {count} more on the Customers page" |
*
* @param {Partner_Home_Waiting_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_waiting_more = /** @type {((inputs: Partner_Home_Waiting_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Waiting_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`und ${i?.count} weitere auf der Kundenseite`)
	return /** @type {LocalizedString} */ (`and ${i?.count} more on the Customers page`)
});